import React from "react";

import { faLightbulb } from "@awesome.me/kit-4c83d50d0d/icons/classic/solid";

import { useAskFellowButton } from "~/nav/panels/AskFellow/AskFellowHooks";
import Menu from "~/ui/menu";

import { ReactComponent as AskFellowIcon } from "./ask-fellow-outline-small.svg";
import { type AbstractAction, ActionButton } from "./shared";

import type { AskFellowHooks_useAskFellowButton_note$key } from "~/__generated__/AskFellowHooks_useAskFellowButton_note.graphql";

import styles from "./AskFellow.module.css";

const ACTION_ID = "ask-fellow" as const;

function Button({ note: noteKey }: { note: AskFellowHooks_useAskFellowButton_note$key }) {
	const onCreateConversation = useAskFellowButton({ noteKey });

	return (
		<ActionButton className={styles.askFellowButton} actionId={ACTION_ID} onClick={onCreateConversation}>
			<AskFellowIcon />
			<span className={styles.askFellowButtonLabel}>Ask Fellow</span>
		</ActionButton>
	);
}

function MenuItem({ note: noteKey }: { note: AskFellowHooks_useAskFellowButton_note$key }) {
	const onCreateConversation = useAskFellowButton({ noteKey });

	return (
		<Menu.Item icon={faLightbulb} onSelect={onCreateConversation}>
			Ask Fellow
		</Menu.Item>
	);
}

export default {
	id: ACTION_ID,
	button: Button,
	menuItem: MenuItem,
} satisfies AbstractAction;
